module.exports = __webpack_public_path__ + "img/img.14be131c.png";